import React from 'react';
import PropTypes from 'prop-types';

class Clear extends React.Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={this.props.size}
        height={this.props.size}
        viewBox="0 0 16 16"
      >
        <title>Clear</title>
        <path
          fill={this.props.fillColor}
          d="M15.5,8A7.5,7.5,0,1,1,8,.5,7.5,7.5,0,0,1,15.5,8ZM5.9,4.8A.8.8,0,0,0,4.8,5.9L6.9,8,4.8,10.1a.8.8,0,0,0,1.1,1.1L8,9.1l2.1,2.1a.8.8,0,1,0,1.4-.8l-.3-.3h0L9.1,8l2.1-2.1a.8.8,0,0,0-1.1-1.1h0L8,6.9Z"
        />
      </svg>
    );
  }
}

Clear.defaultProps = {
  size: '15',
  fillColor: '#000',
};

Clear.propTypes = {
  size: PropTypes.string,
  fillColor: PropTypes.string,
};

export default Clear;



// WEBPACK FOOTER //
// ./src/reactModules/shared/library/FormControls/graphics/Clear.js